<template functional>
<v-card flat class="primary white--text">
  <v-container>
  <ul class="footer-list">
    <li class="footer-item"><router-link :to="{name: 'home'}">Topページ</router-link></li>
    <li class="footer-item"><router-link :to="{name: 'about'}">カライイネとは？</router-link></li>
    <li class="footer-item"><router-link :to="{name: 'kiyaku'}">利用規約</router-link></li>
    <li class="footer-item"><a href="https://twitter.com/karaiine_jp" target="_blank">運営</a></li>
    <li class="footer-item"><a href="https://forms.gle/j2LyBhhe7pbn9q8q8" target="_blank">お問い合わせ</a></li>
  </ul>
  <div style="text-align:center;margin:16px 0;">
    <h3>運営SNSアカウント</h3>
    <a href="https://twitter.com/karaiine_jp" target="_blank">
      <div style="width: 200px;border: solid 1px #fff;padding-top:16px;border-radius:16px;margin:10px auto;">
        <p style="padding-bottom:0">follow me...</p>
        <p>
          <v-icon color="white" size="55">fab fa-twitter</v-icon>
        </p>
      </div>
    </a>
  </div>
  <p class="copyright">Copyright © 2019 カライイネ All Rights Reserved.</p>
  </v-container>
</v-card>
</template>

<script>
export default {
  name: 'CommonFooter'
}
</script>

<style scoped>
.footer-list {
  margin: 0 auto;
  text-align: center;
  font-size: 0;
}
.footer-list .footer-item {
  display: inline-block;
  padding: 0 15px;
  font-size: 0.8rem;
}
.footer-list .footer-item + .footer-item {
  border-left: 1px solid #ddd;
}
.copyright {
  margin-top: 30px;
  text-align: center;
  letter-spacing: 1px;
  font-size: 0.8rem;
}
a {
  color: #fff !important;
  text-decoration: none;
}
</style>
